/**
 * FallbackNotice — Indicator when remediation guidance is fallback (unmapped issue).
 *
 * Displays a banner showing that generic guidance is being used, not specific mapping.
 */

interface FallbackNoticeProps {
  issueKey: string;
  className?: string;
}

export function FallbackNotice({
  issueKey,
  className = "",
}: FallbackNoticeProps) {
  return (
    <div className={`fallback-notice alert alert--info ${className}`}>
      <strong>Generic Guidance:</strong> No specific mapping available for{" "}
      <code>{issueKey}</code>. These are general remediation steps;
      implementation may vary based on the specific context.
    </div>
  );
}
